var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-flex middle-xs tag-wrap relative mx5 my5 pointer",class:{ active: _vm.isActive },on:{"click":_vm.categorySearch}},[_c('span',[_vm._v(_vm._s(_vm.category.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }